import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: {
          'Image name shall be ANSI characters with .png or .jpg extension': 'El nombre de la imagen deberá estar en caracteres ANSI con extensión .png o .jpg',
          'Incorrect padding': 'Relleno incorrecto',
        },
      },
    },
    lng: 'es', // Idioma por defecto
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
